module.exports = __webpack_public_path__ + "static/media/farm.f54b5c8e.svg";